import React, { FC } from 'react';
import Helmet from 'react-helmet';

import { TStyrene } from '../models/font-styrene';
import { FONT_PATH } from '../config';

export const FontStyrene: FC<TStyrene> = ({ children, dataTestId = 'font-styrene', styles }) => {
    return (
        <>
            <Helmet>
                <link href={FONT_PATH} rel="stylesheet" />
            </Helmet>
            <div className={styles.fontStyrene} data-test-id={dataTestId}>
                {children}
            </div>
        </>
    );
};
